import { useEffect, useState } from 'react';
import apiService from '../../services/apiService';
import { RaidLoggedEncounterTable } from '../presentational/raidLoggedEncounterElements';
import { Spinner } from '../../../../../../shared/frontend/components/presentational/spinner';

export function BossAttempts(encounter: any) {
  const [attempts, setAttempts] = useState<null | any[] | Error>(null);

  useEffect(() => {
    apiService.getGuildBossAttempts(
      {
        raid: encounter.raid.slug,
        boss: encounter.boss.slug,
        difficulty: encounter.raid.difficulty,
        region: encounter.guild.region.slug,
        realm: encounter.guild.realm.slug,
        guild: encounter.guild.name,
        limit: 999
      },
      (err, response) => {
        if (err) {
          setAttempts(new Error('Error when loading the pulls'));
          return;
        }

        setAttempts(response.bossAttempts);
      }
    );
  }, [
    encounter.boss.slug,
    encounter.raid.slug,
    encounter.raid.difficulty,
    encounter.guild.realm.slug,
    encounter.guild.region.slug,
    encounter.guild.name
  ]);

  if (attempts === null) {
    return (
      <div>
        <Spinner />
      </div>
    );
  }

  if (attempts instanceof Error) {
    return (
      <div style={{ backgroundColor: '#1a1716' }}>
        <div className="rio-panel--alert bare">
          <i className="fa fa-exclamation-triangle text-warn" />{' '}
          <i>An error occurred when trying to display the pulls for this boss.</i>
        </div>
      </div>
    );
  }

  return (
    <div>
      <RaidLoggedEncounterTable
        encounters={attempts}
        guild={encounter.guild}
        bossKillHeaderVariant="compact"
        columns={['pull_number', 'overall_percent', 'duration', 'item_level', 'composition', 'relative_date']}
      />
    </div>
  );
}
